import { getCapturedSegmentId } from "../hooks/useSegmentCapture";

/**
 * maps the currentUser object to the properties sent with identify
 * - ids and flags only: no email, name or company until consent is settled
 */
export const buildUserTraits = user => {
  const traits = {
    paid_user: user.paidUser,
    full_download_access: user.fullDownloadAccess,
    media_type: user.mediaType,
    is_internal: user.adminUser,
    migrated_user: user.migratedUser,
    team_id: user.team?.id,
    team_enterprise: user.team?.enterprise,
    project_count: user.projects?.length,
    segment: getCapturedSegmentId()
  };

  return Object.fromEntries(
    Object.entries(traits).filter(([, value]) => value != null)
  );
};
